module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M13.86,4.77,27.69,22.05h-.1L30,25l-2.38,2.94h.07L13.86,45.22a3.12,3.12,0,0,0,.46,4.14,3,3,0,0,0,4.14-.46L36.1,26.83A2.69,2.69,0,0,0,36.74,25h0a4.34,4.34,0,0,0-.64-1.84L18.45,1.1A3,3,0,0,0,14.32.64,3.06,3.06,0,0,0,13.86,4.77Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Arrow.svg
// module id = 507
// module chunks = 1